module.exports = __webpack_public_path__ + "static/acto-logo-c461df8b5ccbe26474302585d2c47256.png";